const sales = [
    {
        id: 1,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Efficiency Improvement Drive For Sales"
    },
    {
        id: 2,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Sales Excellence"
    },
    {
        id: 3,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Foundation for Effective Sales Teams"
    },
    {
        id: 5,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Effective Sales Performance"
    },
    {
        id: 6,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Managing Sales Territories"
    },
    {
        id: 7,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Forecasting Sales Revenue"
    },
    {
        id: 8,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Motivating Sales Teams"
    },
    {
        id: 9,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Business Strategy"
    },
    {
        id: 10,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Succession Planning for Sales"
    },
    {
        id: 11,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Recruiting Sales Professionals"
    },
    {
        id: 12,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Motivating Sales Teams for Better Performance"
    },
    {
        id: 13,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Sales & Negotiation Skills"
    }
]

export default sales